<template>
  <div class="mainUser">
    <menberMenu :tit-names="titNames" :tit-urls="titUrls"></menberMenu>
    <div class="mainBox">
      <div class="listContent">
        <div class="content">
          <div class="contentText clear" style="padding:20px">
            <ul class="l">
              <li class="succed-title">
                <i class="fa fa-finish  marR5"></i>
                <span class="title">Place an order successfully</span>
              </li>
              <li style="margin:15px 0">
                <label><span class="colGray9">Order No.：</span>
                  <router-link :to="{name:'airDetails',path:'/air/airDetails',query:{ord:WaybillNO}}"><a class="colBlue"><b>{{WaybillNO}}</b></a></router-link>
                </label>
                <label style="color:#ddd;margin:0 20px">|</label>
                <label><span class="colGray9">Estimated total cost：</span><b class="colRed">US ${{Number(ordCost).toFixed(2)}}</b></label>
              </li>
              <li>
                <div class="colRed">
                  <p v-show="ordCost > BillConvertAmount"><i class="fa fa-tips marR5" style="margin-top:-3px;"></i><span>The order will not be processed until the payment is completed. Please pay according to the estimated cost!</span></p>
                  <p v-show="ordCost <= BillConvertAmount"><i class="fa fa-tips marR5" style="margin-top:-3px;"></i><span>The order will not be processed until the payment is completed</span></p>
                </div>
              </li>
            </ul>
            <ul class="r">
              <li>
                <a class="s-blueBtn" @click="clkMake">Recharge</a>
              </li>
              <li class="marTop10">
                <router-link :to="{name:'airDetails',path:'/air/airDetails',query:{ord:WaybillNO}}"><a class="colBlue s-blueBtn">Details</a></router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--工厂信息-->
      <div class="editCont" v-show="userType == 3 || userType == 2">
        <div class="contTitle">
          <div>Fill in the factory/supplier contact information right now</div>
        </div>
        <div class="content">
          <div class="handle-btn">
            <button @click="clkSendAddrBox">Details info</button>
            <button @click="discernBox=true;discernInfo=''">Copy Here</button>
          </div>
          <form id="airEditValidation">
            <div>
              <div class="contact-container">
                <div class="contact-item">
                  <div>Contact name：</div>
                  <input type="text" class="inputLine" placeholder="Please fill in the contact name" v-model="Factory.FactoryContactName" data-validation-engine="validate[custom[onlyLetterSign] maxSize[200]]" />
                </div>
                <div class="contact-item">
                  <div>Contact number：</div>
                  <input type="text" placeholder="Please fill in the contact number" v-model="Factory.FactoryContactTelephone" data-validation-engine="validate[custom[onlyLetterNumber] maxSize[30]]">
                </div>
                <div class="contact-item">
                  <div>Contact Email.：</div>
                  <input type="text" placeholder="Please fill in the contact email" v-model="Factory.FactoryContactEmail" data-validation-engine="validate[custom[onlyLetterNumber],,custom[email] maxSize[30]]">
                </div>
              </div>
              <div class="contact-container">
                <div class="contact-item contact-item-email">
                  <div>Add.：</div>
                  <input type="text" placeholder="Please fill in the detailed address where the goods are located" v-model="Factory.FactoryAddress" data-validation-engine="validate[custom[onlyLetterNumber], maxSize[200]]" />
                </div>
                <button @click="submit">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="listContent">
        <div class="contTitle">
          In order not to affect the normal delivery of your goods, you need to complete the following matters:
        </div>
        <!-- <div class="content">
          <div class="contentText" style="padding:20px">
            <table border="0" cellspacing="0" cellpadding="0" width="100%" class="TableCss dataInput">
              <tr>
                <td align="left" class="veTop" width="4%;"><span class="radNum">1</span></td>
                <td>
                  <h3>Print label</h3>
                  <p class="colGray9" style="line-height:20px;">In order to ensure the accurate warehousing of your goods without delay, please inform your supplier to <span class="colBlue" style="text-decoration:underline;cursor:pointer;" @click="clkPrintBtn">print the address label</span> on the side of each package.</p>
                </td>
              </tr>
              <tr>
                <td style="padding:0"></td>
                <td style="padding:0">
                  <b>Please inform your supplier to prepare the goods as described above.</b><a class="lineBlueBtn marL30" @click="clkNotiBtn">Notify my supplier</a>
                </td>
              </tr>
              <tr>
                <td align="left" class="veTop"><span class="radNum">2</span></td>
                <td>
                  <h3>Please kindly inform your exclusive salesman.</h3>
                  <div class="clear">
                    <b>
                      In order to ensure the smooth delivery of the goods, please kindly inform your exclusive salesman..
                    </b>
                    <a class="lineBlueBtn  marL30" @click="clkNoteSale">Notify my exclusive salesman</a>
                  </div>
                </td>
              </tr>
              <tr>
                <td align="left" class="veTop"><span class="radNum">3</span></td>
                <td>
                  <h3>Upload invoice and packing list</h3>
                  <p class="colGray9" style="line-height:20px;">Once you have received the invoice and packing list from your supplier, please kindly upload them in the attached information of the air freight order details.
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </div> -->
        <div class="order-handle-container">
          <div class="order-handle">
            <div class="index">1</div>
            <div class="handle-left">
              <div class="title">Print label</div>
              <div class="text">In order to ensure the accurate warehousing of your goods without delay please inform your supplier toPrint the address label on the side of each package.</div>
            </div>
            <button @click="clkPrintBtn">Print the address label</button>
          </div>
          <div class="order-handle">
            <div class="index">2</div>
            <div class="handle-left">
              <div class="title">Inform the factory/supplier</div>
              <div class="text">Please kindly inform the factory/supplier that Freightshop will act as your nominated freight forwarder to handle this shipment to avoid unnecessary delays. Thank you!</div>
            </div>
            <button @click="clkNotiBtn">Notify my factory/Supplier</button>
          </div>
          <div class="order-handle">
            <div class="index">3</div>
            <div class="handle-left">
              <div class="title">Upload invoice and packing list</div>
              <div class="text">Once you have received the invoice and packing list from your supplier please kindly upload them in the attached information of the air freight order details.</div>
            </div>
            <button @click="goDetailDocument">Upload right now</button>
          </div>
        </div>

      </div>

    </div>
    <!-- 打印标签弹框 -->
    <printlabelBox ref="prantBox" :orderNoEnven="this.WaybillNO"></printlabelBox>
    <!--遮罩层-->
    <div class="frameBg" v-show="showModal"></div>
    <div class="frameInput2" v-show="supplierBox">
      <div class="frameHead indexHead clear">
        <p class="l">Notify my supplier</p>
        <p @click="getClose" class="r" style="font-size:26px;">×</p>
      </div>
      <div class="content" style="padding:0 25px;">
        <table border="0" cellspacing="0" cellpadding="0" class="TableCss marTop30">
          <tr>
            <td colspan="2" align="left">
              <b>Order No.：{{WaybillNO}}</b>
              <p class="colGray">Order labels and stocking precautions will be notified to your supplier via email.</p>
            </td>
          </tr>
          <tr>
            <td width="13%" align="right" class="veTop">
              <h3>Emali：</h3>
            </td>
            <td>
              <input type="text" class="inputLine" style="width:90%;" v-model="emaliInput" @blur="blurInput" />
              <p class="colRed" v-show="showEmaliMsg">Please enter a valid email address</p>
            </td>
          </tr>
        </table>
      </div>
      <div class="framePwBtn">
        <a style="margin-left:31%;font-size:13px;" class="sureLineA l" @click="getClose">Cancel</a>
        <a class="sureA l marL10" style="font-size:13px;" @click="clkSendBtn" v-if="isSend">Send notification</a>
        <a class="sureA l marL10" style="font-size:13px;background:#bbb;cursor:default;" v-if="!isSend">Sending...</a>
      </div>
    </div>
    <!-- -----------------弹框信息部分 ----------------->
    <senderAddrBox ref="senderBox" @senderMsgEvent="showMsgSender"></senderAddrBox> <!-- 发件人地址库弹框 -->
    <!--工厂信息弹框-->
    <el-dialog title="Quick order" :visible.sync="discernBox" :close-on-click-modal="false" custom-class="addOrd discernBox airSucceedFactoryDialog" width="600px">
      <div class="content">
        <div class="text">
          Paste the whole address, automatically identify the name, telephone, email and address, and separate the information with commas
        </div>
        <div>
          <el-input type="textarea" :rows="4" :class="(discernInfoTip && !discernInfo)?'inputWarn':''" maxlength="500" placeholder="For example: Alice,13988888888， tom@gmail.com，room 1004 XXXX building Dongguan City Guangdong Province" v-model="discernInfo"></el-input>
        </div>
        <div class="foot">
          <div class="btn">
            <div class="lineBlueBtnW cursor" @click="pickAddr">Confrim</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import { post, fetch, Del, put } from "../../../ask/axios";
import menberMenu from '../../../components/userCenter/public/menberPageMenu.vue'
import printlabelBox from '../public/printlabelBox.vue' //打印标签
import senderAddrBox from "../public/senderAddrBox.vue"; //发件人地址库
export default {
  components: { menberMenu, printlabelBox, senderAddrBox },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
      //工厂信息
      Factory: {
        FactoryContactName: '',//工厂名称
        FactoryContactTelephone: '',//电话
        FactoryContactEmail: '',//email
        FactoryAddress: '',//工厂地址
      },
      discernBox: false,//工厂信息弹框
      discernInfoTip: false,//Quick order 弹框
      discernInfo: '',//Quick order信息
      titNames: "Air Freight Shipment,Booked",
      titUrls: "/air/airList,",

      //弹框
      showModal: false,
      supplierBox: false,
      emaliInput: '', //邮箱Input

      WaybillNO: '',//订单号
      OrderServiceType: null,//订单类型
      ordCost: null,//预估费用

      shipperEmali: '', //发送给供应商邮箱
      showEmaliMsg: false, //提示不能为空

      BillConvertAmount: null,//账户余额

      isSend: true,
      userType: 0,//是否海外同行  客户归属类型 0：直客，1：国内同行，2：海外同行 3:对接平台客户
    }
  },
  created() {
    this.costApi();
    this.WaybillNO = this.$route.query.ord
    this.ordCost = this.$route.query.ordNumCost
    this.OrderServiceType = this.$route.query.OrderServiceType
  },
  mounted() {
    this.userType = JSON.parse(
      sessionStorage.getItem("customerInfos")
    ).CustomerOwnerType;
    this.getValidation()
  },
  methods: {
    //验证调取
    getValidation() {
      $("#airEditValidation").validationEngine();
      console.log($("#airEditValidation").validationEngine(), $("#airEditValidation"), '$("#airEditValidation").validationEngine()');
    },
    getCheckForm() {
      return $("#airEditValidation").validationEngine("validate");
      //$('#form1').validationEngine('validate')
    },
    // 修改工厂信息
    submit() {
      //验证方法
      event.preventDefault()
      let isCheck = this.getCheckForm();
      console.log(isCheck, "isCheck");
      if (!isCheck) {
        return false;
      }
      let url = this.$api04 + '/Air/api/AirOrderEn/FactoryOperate'
      let params = {
        factoryContactName: this.Factory.FactoryContactName,//工厂名称
        factoryContactTelephone: this.Factory.FactoryContactTelephone,//电话
        factoryContactEmail: this.Factory.FactoryContactEmail,//email
        factoryAddress: this.Factory.FactoryAddress,//地址
        waybillNO: this.$route.query.ord,//订单号
      }
      if (this.Factory.FactoryContactName || this.Factory.FactoryContactTelephone || this.Factory.FactoryContactEmail || this.Factory.FactoryAddress) {
        post(url, params).then(res => {
          if (res.Results) {
            this.$message.success('modify successfully')
          } else {
            this.$message.error(res.Message)
          }
        })
      } else {
        this.$message.error('Please fill in')
      }
    },
    //点击立即充值
    clkMake() {
      window.location.href = '/payment/myPayment?ordCost=' + Number(this.ordCost).toFixed(2)
    },
    goDetailDocument() {
      let resolved = this.$router.resolve({
        path: "/air/airDetails",
        query: {
          ord: this.WaybillNO, // 判断是海外同行还是直客
          from: 1
        }
      });
      window.open(resolved.href, '_blank');
    },
    pickAddr() {
      if (!this.discernInfo) {
        this.discernInfoTip = true
        return false
      }
      let url = this.$api02 + '/api/EbayCustomer/PickupAddr/DiscernEn'
      let param = {
        "textbox": this.discernInfo
      }
      fetch(url, param).then(res => {
        if (res.IsOK) {
          this.Factory.FactoryContactName = res.Results.FullName;
          this.Factory.FactoryContactTelephone = res.Results.Phone;
          this.Factory.FactoryContactEmail = res.Results.Mailbox;
          this.Factory.FactoryAddress = res.Results.Address;
        }
      });
      // 结束
      this.discernBox = false
    },
    //发件人地址库点击选择按钮
    showMsgSender(msg) {
      //工厂信息
      this.Factory.FactoryContactName = msg.Address_Name;
      this.Factory.FactoryContactTelephone = msg.Address_Tel;
      this.Factory.FactoryContactEmail = msg.Address_Mail;
      this.Factory.FactoryAddress = msg.Address_Street;
    },
    //发件人地址栏弹框
    clkSendAddrBox(val) {
      this.$refs.senderBox.clkDialog();
    },
    //美元账户余额查询
    costApi() {
      let that = this;
      this.api.param = {
        QueryType: 1
      }
      this.api.url = this.$api02 + "/api/EbayCustomer/MyBill/GetCusAmount";
      post(this.api.url, this.api.param).then(function (res) {
        if (res.Results) {
          that.BillConvertAmount = res.Results.BillConvertAmount
        }
      })
    },
    //打印标签
    clkPrintBtn() {
      this.$refs.prantBox.clkDialog(this.$route.query.Qty);
    },
    printMsgEvent(msg) {

    },

    //关闭弹框
    getClose() {
      this.showModal = false
      this.supplierBox = false
      this.showEmaliMsg = false
    },
    //点击notify按钮
    clkNotiBtn() {
      this.showModal = true
      this.supplierBox = true
      this.emaliInput = this.$route.query.shipperEmali
    },
    //点击notify按钮
    clkNoteSale() {
      this.api.param = {
        WaybillNO: this.WaybillNO,
      }
      this.api.url = this.$api03 + "/api/TradeCustomer/Email/AirSendEmailNotifyTheSalesman";
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK) {
          this.$alert('successfully', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showClose: true,//去掉右上角的取消（X）
            center: true
          }).then(() => {
          }).catch(() => {
          });
        } else {
          this.$alert('fail', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showClose: true,//去掉右上角的取消（X）
            center: true
          }).then(() => {
          }).catch(() => {
          });
        }
      })
    },
    //验证邮箱是否为空 和邮箱格式验证
    blurInput() {
      let validEm = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!validEm.test(this.emaliInput)) {
        this.showEmaliMsg = true
      } else {
        this.showEmaliMsg = false
      }
    },
    //点击发送按钮
    clkSendBtn() {

      if (this.showEmaliMsg || !this.emaliInput) {
        this.showEmaliMsg = true
        return false
      } else {
        this.showEmaliMsg = false
        this.sendEmaliApi();
      }

      // if(!this.emaliInput){
      //    this.showEmaliMsg=true
      //    return false
      // }else{
      //   this.showEmaliMsg=false
      //   this.sendEmaliApi();
      // }
    },
    //发送邮箱给供应商接口
    sendEmaliApi() {
      let that = this;
      this.api.param = {
        WaybillNO: this.WaybillNO,
      }
      //邮箱 this.emaliInput
      let em = that.emaliInput.split(',')
      this.api.param.Emails = em

      this.isSend = false
      // this.api.url=this.$api02+"/api/EbayCustomer/SupplierInfo/NewAccountInfoSendEmail";
      this.api.url = this.$api02 + "/api/EbayCustomer/SupplierInfo/NewAccountInfoAirSendEmail";
      post(this.api.url, this.api.param).then(function (res) {
        if (res.ErrorCode == 'C0001') {
          that.$message({
            message: 'You have successfully notified your supplier!',
            type: 'success'
          });

          that.isSend = true
          that.showModal = false
          that.supplierBox = false
          // that.$confirm("You have successfully notified your supplier!", "", {
          //   customClass: "custom-message-box", //自定义添加Class
          //   confirmButtonText: "Confirm",
          //   cancelButtonText: "Cancel",
          //   cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
          //   closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
          //   showCancelButton: false, //去掉取消按钮
          //   showClose: false, //去掉右上角的取消（X）
          //   // type: 'warning',
          //   center: true
          // }).then(() => {
          //   that.showModal=false
          //   that.supplierBox=false
          // }).catch(() => {
          //    that.showModal=false
          //    that.supplierBox=false
          // });
          return false;
        } else if (res.IsOK == false || res.ErrorCode == 'C0002') {
          that.isSend = true
          that.$confirm("failed!", "", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
            that.showModal = false
            that.supplierBox = false
          }).catch(() => {
            that.showModal = false
            that.supplierBox = false
          });
        }
      })
    },

  }
}
</script>

 <style>
/*局部修改elementUI样式*/
/*!*取消按钮*!*/
/*.el-message-box__wrapper .btn-custom-cancel {float:right;margin:0 120px 0 0 !important;;}*/
/*!*确定或者删除按钮*!*/
/*.el-message-box__wrapper .el-message-box__btns button:nth-child(2){margin:0 0 0 120px !important;}*/
@import "../../../assets/css/tipsMessage.css";
</style>
<style scoped lang="scss">
@import "../../../assets/css/userCenterCss.css";
@import "../../../assets/css/frame.css";
.radNum {
  background: #f2f2f2;
  border-radius: 30px;
  padding: 5px 10px;
  color: #999;
}
.succed-title .title {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  vertical-align: top;
  line-height: 28px;
}
.succed-title i {
  color: #1aad19;
  font-size: 26px;
}
.s-blueBtn {
  border: 1px solid #004fb1;
  border-radius: 30px;
  background: #004fb1;
  color: #fff !important;
  width: 98px;
  height: 28px;
  display: block;
  text-align: center;
  line-height: 28px;
}
.contTitle {
  padding: 0 24px !important;
  line-height: 48px;
  background: #f8f8f8;
  border-radius: 8px 8px 0px 0px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #777777;
}
.handle-btn {
  line-height: 56px;
  padding-left: 24px;
  button {
    outline: none;
    width: 80px;
    padding: 0;
    height: 24px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #014fb1;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 12px;
    color: #004fb1;
    cursor: pointer;
  }
}
.contact-container {
  display: flex;
  padding: 0 24px;
  justify-content: space-between;
  position: relative;
  .contact-item {
    display: flex;
    height: 30px;
    align-items: center;
    width: calc((100% - 32px) / 3);
    position: relative;
    // padding-right: 16px;
    /deep/ .formError {
      left: 100px !important;
    }
    div {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #000000;
    }
    input {
      background: #ffffff;
      border: 1px solid #d9d9d9;
      padding: 0 8px;
      border-radius: 4px;
      height: 30px;
      line-height: 30px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      flex: 1;
      transition: all 0.2s;
      &:hover {
        border: 1px solid #aaaaaa !important;
        transition: all 0.2s;
      }
      &:focus {
        border: 1px solid #0046b9 !important;
        transition: all 0.2s;
      }
      &::placeholder {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #bababa;
      }
    }
  }
  .contact-item-email {
    width: calc(100% - 104px);
    margin: 16px 0 24px;
    /deep/ .formError {
      left: 28px !important;
    }
  }
  button {
    outline: none;
    width: 88px;
    height: 30px;
    background: #004fb1;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    border: none;
    margin-top: 16px;
  }
}
.order-handle-container {
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
  border-radius: 0 0 10px 10px;
  border: 1px solid #d8d8d8;
  padding: 16px 24px 16px;
  overflow: hidden;
}
.order-handle {
  min-height: 71px;
  background: #f9fafb;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 0 32px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 8px;
  .index {
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 8px 0px 8px 0px;
    text-align: center;
    line-height: 24px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: bold;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.56);
  }
  .handle-left {
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 13px;
      color: #000000;
      line-height: 18px;
      margin-bottom: 4px;
    }
    .text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #4a4a4a;
    }
  }
  button {
    outline: none;
    width: 176px;
    flex-shrink: 0;
    height: 26px;
    border-radius: 100px;
    border: 1px solid #004fb1;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #004fb1;
    background: #f9fafb;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
// 遮罩层
.airSucceedFactoryDialog {
  border-radius: 5px;
  overflow: hidden;
  .el-dialog__header {
    font-size: 12px;
    padding: 0 24px 0;
    line-height: 56px;
    .el-dialog__title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 550;
      color: #333;
    }
    .el-dialog__headerbtn {
      top: 20px;
    }
  }
  .el-dialog__body {
    padding: 0;
    .content {
      font-size: 12px;
      padding: 0px 24px;
      max-height: 300px;
    }
    .text {
      line-height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin-bottom: 16px;
    }
    .queryTH {
      min-height: 200px;
    }
    .foot {
      text-align: center;
      .btn {
        width: 300px;
        margin: auto;
        padding: 10px 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/userCenter/air/airSucceed.vue